<section>
  <article style="background-color: #294058">
    <div class="container-fluid">
      <div class="container df" style="height:inherit !important">
        <div class="vertical_page mrAuto df" style="z-index: 100;">
          <div class="container_form">
            <div class="df">
              <div class="heading">SDT FOR DEVICE(S)</div>
            </div>
            <div class="pd20">
              <div class="" style="text-align: center;">
                <div class="">
                  <span><b>DEVICE(S) NAME</b></span><br>
                </div>
                <div class="p5 sdtinfo box">
                  <div *ngIf="deviceNames.length == 0; then errorBlock else showBlock"></div>
                  <ng-template #errorBlock><p style="color: red;">Please add device(s) for SDT</p></ng-template>
                  <ng-template #showBlock>{{deviceNames}}</ng-template>
              </div><br>
                </div>
              <div class="df">
                <form [formGroup]="sdtForm" style="width: 100%;">
                  <div class="d_res">
                    <mat-form-field appearance="outline">
                        <mat-label><b>SDT From Date</b></mat-label>
                        <input matInput readonly [matDatepicker]="picker" [(ngModel)]="start"
                          (dateChange)="onDateChange($event)" [min]="formExists?start:minDateFrom"
                          autocomplete="off" class="form-control" formControlName="start_date" class="bgNone" [disabled]="linkedForm">
                          <mat-hint>MM-DD-YYYY</mat-hint>
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                      <mat-error>
                        Please Select SDT Start Date.
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="mrAuto">
                      <mat-label><b>SDT To Date</b></mat-label>
                      <input matInput readonly [matDatepicker]="picker1" [(ngModel)]="end" [min]="fromDateMinDate"
                        [max]="toDateMaxDate" autocomplete="off" class="form-control" formControlName="end_date"
                        class="bgNone" (dateChange)="onToDateChange($event)" [disabled]="linkedForm">
                      <mat-hint>MM-DD-YYYY</mat-hint>
                      <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                      <mat-datepicker #picker1></mat-datepicker>
                      <mat-error>
                        Please Select SDT End Date.
                      </mat-error>
                    </mat-form-field>

                  </div>
                  <div class="pd20 reason">REASON</div>
                  <div class="dfk" style="display: flex;">
                    <div style="width:100% !important">
                      <mat-form-field appearance="outline" class="outline">
                        <mat-select [(ngModel)]="selectedOption" (selectionChange)="changeReason($event)" formControlName="reason"
                          placeholder="Choose a Reason" style="text-align: center;">
                          <mat-option>Select
                          </mat-option>
                          <mat-option *ngFor="let reasn of Reason" [value]="reasn">{{reasn}}
                          </mat-option>
                        </mat-select>
                        <mat-error>Please Choose a Reason</mat-error>
                      </mat-form-field>
                    </div>
               
                    <div style="width:100% !important" *ngIf="selectedOption == 'Other'">
                      <mat-form-field class="df"  floatLabel="never" appearance="outline" hintLabel="Max 40 characters" style="width: 100%;">
                        <textarea matInput #txtarea matInput  [maxLength]="40"  placeholder="Other Reason *" formControlName="otherReason"
                          class="otherReason">
                         </textarea>
                        <mat-error>Please Enter a Reason</mat-error>
                      </mat-form-field>
                    </div>
                 
                  </div>                  
                  <div class="pd20">
                    <div class="submit_button">
                      <div class="display_flex">
                        <button type="button" class="fancy-button medium sun vertical" (click)="back()">
                          Back
                        </button>
                        <button type="button" (click)="onSubmit()" class="btn btn-primary" class="fancy-button medium sun vertical">
                        Submit
                      </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </article>
</section>